import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/paginaprincipal";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import RTLDefault from "views/rtl/default";
import Seleccion from "views/admin/tables2";
import Registro from "views/admin/registroempleados";
import Perfiles from "views/admin/perfiles";
import Chatai from "views/admin/chatai";
import Reglamento from "views/admin/reglamento";
import Evaluacion from "views/admin/evaluacion";
import Descargos from "views/admin/descargos";
import Personal from "views/admin/personal";
import Capacitaciones from "views/admin/capacitaciones";
import Procesos from "views/admin/procesos";
import Descargoslab from "views/admin/descargoslab";
import Descargoslista from "views/admin/descargoslista";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock,
  MdExpandMore,
} from "react-icons/md";

const routes = [

      {
    name: "Inicio",
    layout: "/admin",
    path: "paginaprincipal",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <NFTMarketplace />,
    
  },
  {
    name: "Perfil Personal",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
    secondary: true,
  },

  {
    name: "Registro de Personal",
   layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "data-tables",
    component: <DataTables />,
  }, 
  
  {
    name: "Seleccion de personal",
    layout: "/admin",
    path: "default",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <MainDashboard />,
    
  },

  {
    name: "Registro de Personal",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "tables",
    component: <DataTables />,
  }, 
  {
    name: "Mi perfil personal",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
  {
    name: "Reglamento Empresa",
    layout: "/rtl",
    path: "rtl",
    icon: <MdHome className="h-6 w-6" />,
    component: <RTLDefault />,
  },
  {
    name: "Reglamento",
    layout: "/views",
    path: "rtl",
    icon: <MdHome className="h-6 w-6" />,
    component: <RTLDefault />,
  },
  {
    name: "Reporte Descargos Laborales",
    layout: "/rtl",
    path: "rtl",
    icon: <MdHome className="h-6 w-6" />,
    component: <RTLDefault />,
  },
  {
    name: "Diagnostico y pruebas",
    layout: "/rtl",
    path: "rtl",
    icon: <MdHome className="h-6 w-6" />,
    component: <RTLDefault />,
  },
  {
    name: "Reporte Final",
    layout: "/rtl",
    path: "rtl",
    icon: <MdHome className="h-6 w-6" />,
    component: <RTLDefault />,
  },
  {
    name: "Seleccion",
    layout: "/admin",
    path: "tables2",
    icon: <MdHome className="h-6 w-6" />,
    component: <Seleccion />,
  },

  {
    name: "Registro",
    layout: "/admin",
    path: "registroempleados",
    icon: <MdHome className="h-6 w-6" />,
    component: <Registro />,
  },

  {
    name: "Perfiles",
    layout: "/admin",
    path: "perfiles",
    icon: <MdHome className="h-6 w-6" />,
    component: <Perfiles />,
  },

  {
    name: "Chatai",
    layout: "/admin",
    path: "chatai",
    icon: <MdHome className="h-6 w-6" />,
    component: <Chatai />,
  },

  {
    name: "Reglamento",
    layout: "/admin",
    path: "reglamento",
    icon: <MdHome className="h-6 w-6" />,
    component: <Reglamento />,
  },

  {
    name: "Evaluacion",
    layout: "/admin",
    path: "evaluacion",
    icon: <MdHome className="h-6 w-6" />,
    component: <Evaluacion/>,
  },

  {
    name: "Descargos",
    layout: "/admin",
    path: "descargos",
    icon: <MdHome className="h-6 w-6" />,
    component: <Descargos/>,
  },

  {
    name: "Personal",
    layout: "/admin",
    path: "personal",
    icon: <MdHome className="h-6 w-6" />,
    component: <Personal/>,
  },

  {
    name: "Capacitaciones",
    layout: "/admin",
    path: "capacitaciones",
    icon: <MdHome className="h-6 w-6" />,
    component: <Capacitaciones/>,
  },

  {
    name: "Procesos",
    layout: "/admin",
    path: "procesos",
    icon: <MdHome className="h-6 w-6" />,
    component: <Procesos/>,
  },



  
  {
    name: "Descargoslab",
    layout: "/admin",
    path: "descargoslab",
    icon: <MdHome className="h-6 w-6" />,
    component: <Descargoslab/>,
  },

  {
    name: "Descargoslista",
    layout: "/admin",
    path: "descargoslista",
    icon: <MdHome className="h-6 w-6" />,
    component: <Descargoslista/>,
  },




];

export default routes;
